import { CedenteCadastro } from './cedente-cadastro';
import { GestorCadastro } from './gestor-cadastro';

export class CedenteGestorCadastro  {
    constructor(
        public gestorCadastro: GestorCadastro,
        public cedenteCadastro: CedenteCadastro,
        public perfilNomeNormalizado: string
    ) {}
}
